export enum TypeConditionnement {
  PLIS_ENVELOPPE = 'Enveloppe',
  PLIS_CARTON_D_ARCHIVE = "Carton d'archive",
  COLIS_CARTON = 'Carton',
  COLIS_BULLES = 'Bulles',
  COLIS_CAISSE_EN_BOIS = 'Caisse en bois',
  COLIS_SAC_EN_PLASTIQUE = 'Sac en plastique',
  COLIS_PALETTE = 'Palette'
} 